import styled from 'styled-components'

export const Container = styled.div<any>`
  display: flex;
  user-select: none;
  align-items: center;
  margin: 0 0 30px;

  label {
    color: ${props => props.theme.palette.general.greyDark};
    cursor: ${props => props.isFetching ? 'wait' : 'pointer'};
    display: flex;
    padding: 2px 0;
    align-items: center;
  }

  input {
    cursor: ${props => props.isFetching ? 'wait' : 'pointer'};
  }

  span {
    padding: 0 7px;
  }
`
